import type { UserInfo } from '@vben/types';

import { authApi } from '#/api/modules';

/**
 * 将后端用户数据转换为前端 UserInfo 格式
 *
 * 后端返回的完整字段：
 * - id, username, name, nickname, email, avatar
 * - phone, status, createdAt, updatedAt
 * - lastLoginAt, lastLoginIp
 * - roleNames: 角色名称数组 ["super-admin", "base-user"]
 * - roles: 角色ID数组 ["1", "10"]
 */
function transformBackendUserToUserInfo(backendUser: any): UserInfo {
  const roleNames = backendUser.roleNames?.length
    ? backendUser.roleNames
    : ['user'];

  return {
    // 保留后端的所有原始字段（包括 phone, lastLoginAt 等）
    ...backendUser,

    // 框架必需的基础字段
    userId: String(backendUser.id),
    username: backendUser.username,
    realName: backendUser.nickname || backendUser.name,
    avatar:
      backendUser.avatar ||
      `https://api.dicebear.com/7.x/avataaars/svg?seed=${backendUser.username}`,
    // roles 字段：使用 roleNames（角色名称）以兼容框架的权限系统
    roles: roleNames,
    roleIds: backendUser.roles || [],
    roleNames,

    // 框架扩展字段
    desc: `${backendUser.name} - ${backendUser.email}`,
    homePath: '/workbench', // MES 工作台首页
    token: '', // token 由 accessStore 管理
  };
}

/**
 * 获取用户信息
 */
export async function getUserInfoApi(): Promise<UserInfo> {
  const backendUser = await authApi.me();
  return transformBackendUserToUserInfo(backendUser);
}
